

import { userData } from "services/LoginFunctions"

function dateIsValid(date) { return !isNaN(date.getTime()) }

export function filterDocumentosQueParticipo(listaDocs)
{
    return listaDocs.filter(doc => doc.autenticacao.funcionarios[0].matricula === userData().matricula)
}

function filterProcessosComDocumentos(listaProcs)
{
    return listaProcs.filter(proc =>
    {
        return proc.documentos !== undefined && proc.documentos !== null
    })
}

export function filterProcessosQueParticipo(listaProcs)
{
    const processosComDocs = filterProcessosComDocumentos(listaProcs)
    return processosComDocs.filter(proc =>
    {
        return (0 < proc.documentos.filter(doc => doc.autenticacao.funcionarios[0].matricula === userData().matricula).length)
    })
}

export function FiltrarPropIgualValor(propName, value, processos)
{
    if (!value) { console.log("Tentando filtrar com n° de processo indefinido") ; return processos }

    let processosFiltrados = processos.filter(proc => proc[propName] === value)

    if (processosFiltrados.length <= 0) { return [] }

    return processosFiltrados
}

export function FiltrarPropContem(propName, value, processos)
{
    if (!value) { console.log("Tentando filtrar com n° de processo indefinido") ; return processos }
    
    let processosFiltrados = processos.filter(proc => proc[propName].includes(value.replace("_", "")))

    if (processosFiltrados.length <= 0) { return [] }

    return processosFiltrados
}

export function FiltrarAnalista(value, processos)
{
    if (!value) { console.log("Tentando filtrar com nome de analista indefinido") ; return processos }
    const processosComDocs = filterProcessosComDocumentos(processos)
    processosComDocs.forEach(proc => 0 < proc.documentos.forEach(doc => console.log(doc.autenticacao.funcionarios[0].nome)))
    let processosFiltrados = processosComDocs.filter(proc => 0 < proc.documentos.filter(doc => doc.autenticacao.funcionarios[0].nome.toLowerCase().includes(value.toLowerCase())).length)

    if (processosFiltrados.length <= 0) { return [] }

    return processosFiltrados
}

export function FiltrarData(value, processos)
{
    if (!value) { console.log("Tentando filtrar com data indefinida") ; return processos }
    
    value = value.split("/")

    const dia = value[0]
    const mes = value[1]
    const ano = value[2]
    const dataFiltro = new Date(ano + "-" + mes + "-" + dia)

    if (!dateIsValid(dataFiltro)) { console.log("Tentando filtrar com data inválida") ; return processos}

    return processos.filter(proc => dateIsValid(new Date(proc.createdAt)) && dataFiltro <= new Date(proc.createdAt))
}
